export default __webpack_public_path__ + "static/case-study2-246dab5deb23ef250e066f62110ecf54.jpg";